import { AxiosResponse } from 'axios';
import apiService from './api';
import {
  KpisResponse,
  TimeSeriesResponse,
  EngagementResponse,
  LearningResponse,
  SchoolsResponse,
  StudentsResponse,
  DevicesResponse,
  KpiQueryParams,
  TimeSeriesQueryParams,
  EngagementQueryParams,
  LearningQueryParams,
  StudentsQueryParams,
  DevicesQueryParams,
  TeacherReportResponse,
  TeacherReportQueryParams
} from 'shared/types';

const REPORTS_PATH = '/reports';

export const getKpis = (
  params?: KpiQueryParams
): Promise<AxiosResponse<KpisResponse>> => {
  return apiService.get<KpisResponse>(`${REPORTS_PATH}/kpis`, params);
};

export const getTimeSeries = (
  params?: TimeSeriesQueryParams
): Promise<AxiosResponse<TimeSeriesResponse>> => {
  return apiService.get<TimeSeriesResponse>(`${REPORTS_PATH}/time-series`, params);
};

export const getEngagement = (
  params?: EngagementQueryParams
): Promise<AxiosResponse<EngagementResponse>> => {
  return apiService.get<EngagementResponse>(`${REPORTS_PATH}/engagement`, params);
};

export const getLearning = (
  params?: LearningQueryParams
): Promise<AxiosResponse<LearningResponse>> => {
  return apiService.get<LearningResponse>(`${REPORTS_PATH}/learning`, params);
};

export const getSchools = (): Promise<AxiosResponse<SchoolsResponse>> => {
  return apiService.get<SchoolsResponse>(`${REPORTS_PATH}/schools`);
};

export const getStudents = (
  params?: StudentsQueryParams
): Promise<AxiosResponse<StudentsResponse>> => {
  return apiService.get<StudentsResponse>(`${REPORTS_PATH}/students`, params);
};

export const getDevices = (
  params?: DevicesQueryParams
): Promise<AxiosResponse<DevicesResponse>> => {
  return apiService.get<DevicesResponse>(`${REPORTS_PATH}/devices`, params);
};

export const getTeacherReport = (
  params: TeacherReportQueryParams
): Promise<AxiosResponse<TeacherReportResponse>> => {
  return apiService.get<TeacherReportResponse>(`${REPORTS_PATH}/teacher-report`, params);
};
